/* eslint-disable no-console */
import { API } from '../request/api';
import Store from '../store';
import { _set_cart_data } from '../store/actions/login_actions';
import { name } from './env';

export const calculator = () => {
  const { Login } = Store.getState();
  let cart_credit = 0;
  let total_amount = 0;
  let total_quantity = 0;
  let payable_amount = 0;
  let discount_amount = 0;
  let total_usable_credit = 0;
  const cart = [...new Set(Store.getState().Cart)];

  cart.forEach((x) => {
    total_quantity += x.quantity;
    total_amount += x.quantity * x.price;
    payable_amount += x.quantity * x.payable_amount;
    discount_amount += x.quantity * x.fixed_discount_amount;
    total_usable_credit += x.quantity * x.usable_credit_amount;
  });

  cart_credit = Math.min(Login.credit, total_usable_credit, payable_amount);
  payable_amount = Math.max(payable_amount, 0);

  Store.dispatch(
    _set_cart_data(cart_credit, {
      total_amount,
      total_quantity,
      payable_amount,
      discount_amount,
      total_usable_credit
    })
  );
};

export const Comma = (value) => value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

export const TComma = (value) => Comma(Math.floor(value / 10));

export const DashingCreditCard = (value) => {
  try {
    return value
      .replace(/-/g, '')
      .replace(/(.{4})/g, '$1 ')
      .trim()
      .replace(/\s/g, '-');
  } catch {
    if (value) {
      return value;
    }
    return '-';
  }
};

export const RemoveDashedCreditCard = (value) => value.toString().replace(/-/g, '');

export const FireBaseHandler = (city_id) => {
  const device_token = localStorage.getItem(`${name}-Firebase`);
  if (device_token) {
    API.post
      .firebase(device_token, navigator.platform, navigator.userAgent, city_id)
      .then(() => console.error('Firebase Token Send To Server.'))
      .catch(() => console.error('Error: Firebase Error ( Server )'));
  }
};

export const convertFaToEn = (txt) => {
  const PER_MATCH = /[۰۱۲۳۴۵۶۷۸۹]/g;
  const replacePer = (char) => `${char.charCodeAt(0) - 1776}`;

  if (!txt) return '';
  return txt.replace(PER_MATCH, replacePer);
};

export const convertEnToFa = (str) => {
  const EN_NUM = /[0-9]/g;
  const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];

  if (typeof str === 'string') {
    return str.replace(EN_NUM, (w) => persianDigits[+w]);
  }

  return str || '';
};

export const rangeGenerator = (highEnd, lowEnd) => {
  const list = [];
  for (let i = highEnd; i >= lowEnd; i -= 1) {
    list.push(i);
  }
  return list;
};

export const isDigit = (value) => {
  value = value.replaceAll('۰', '0');
  value = value.replaceAll('۱', '1');
  value = value.replaceAll('۲', '2');
  value = value.replaceAll('۳', '3');
  value = value.replaceAll('۴', '4');
  value = value.replaceAll('۵', '5');
  value = value.replaceAll('۶', '6');
  value = value.replaceAll('۷', '7');
  value = value.replaceAll('۸', '8');
  value = value.replaceAll('۹', '9');
  const reg = /^[\d۰۱۲۳۴۵۶۷۸۹]*?$/;
  return !Number.isNaN(value) && reg.test(value);
};

export const isNumber = (value) => !Number.isNaN(parseFloat(value)) && !Number.isNaN(value - 0);

export const formatNumberWithCurrency = (number) => {
  if (typeof number !== 'string') {
    number = String(number);
  }

  if (number.startsWith('-')) {
    // eslint-disable-next-line prefer-template
    return number.replace('-', '');
  }
  // eslint-disable-next-line prefer-template
  return number;
};

// export const formatNumberWithCurrency = (number) => {
//   if (typeof number !== 'string') {
//     number = String(number);
//   }

//   const currencyText = '<span style="font-size: 1.2em;">تومان</span>';

//   if (number.startsWith('-')) {
//     return number.replace('-', '') + currencyText;
//   }
//   return `${number} ${currencyText}`;
// };
